/**
 * Cart page quantity/remove handling. Listeners are bound to `document`
 * (rather than the `.cart-page` node) because that node is replaced wholesale
 * after every update.
 */
async function updateLine(key, quantity) {
  try {
    const response = await fetch(`${window.Shopify.routes.root}cart/change.js`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity }),
    });
    if (!response.ok) throw new Error('Cart update failed');

    const sectionResponse = await fetch(`${window.location.pathname}?section_id=main-cart`);
    const text = await sectionResponse.text();
    const doc = new DOMParser().parseFromString(text, 'text/html');
    const fresh = doc.querySelector('.cart-page');
    const current = document.querySelector('.cart-page');
    if (fresh && current) current.replaceWith(fresh);
    document.dispatchEvent(new CustomEvent('cart:refresh'));
  } catch (error) {
    console.error(error);
  }
}

// Rapid clicks on +/- otherwise fire a fresh fetch + full-page DOM replace per
// click; overlapping requests race and can leave the cart showing a stale
// quantity. Debounce per line and chain requests so only the latest quantity
// is ever sent, one at a time.
const debounceTimers = new Map();
const updateQueues = new Map();

function runUpdate(key, quantity) {
  const previous = updateQueues.get(key) || Promise.resolve();
  const next = previous.then(() => updateLine(key, quantity));
  updateQueues.set(key, next);
}

function queueUpdate(key, quantity) {
  clearTimeout(debounceTimers.get(key));
  debounceTimers.set(
    key,
    setTimeout(() => {
      debounceTimers.delete(key);
      runUpdate(key, quantity);
    }, 350)
  );
}

document.addEventListener('click', (event) => {
  if (!event.target.closest('.cart-page')) return;

  const removeBtn = event.target.closest('[data-cart-remove]');
  if (removeBtn) {
    const row = removeBtn.closest('[data-cart-item]');
    clearTimeout(debounceTimers.get(row.dataset.key));
    runUpdate(row.dataset.key, 0);
    return;
  }

  const decreaseBtn = event.target.closest('[data-quantity-decrease]');
  const increaseBtn = event.target.closest('[data-quantity-increase]');
  if (decreaseBtn || increaseBtn) {
    const row = event.target.closest('[data-cart-item]');
    const input = row.querySelector('[data-quantity-input]');
    const next = Math.max(0, Number(input.value) + (increaseBtn ? 1 : -1));
    input.value = next;
    queueUpdate(row.dataset.key, next);
  }
});

document.addEventListener('change', (event) => {
  if (!event.target.matches('.cart-page [data-quantity-input]')) return;
  const row = event.target.closest('[data-cart-item]');
  clearTimeout(debounceTimers.get(row.dataset.key));
  runUpdate(row.dataset.key, Math.max(0, Number(event.target.value)));
});
